import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getZasilkovnaCarriersFetchFailure,
    getZasilkovnaCarriersFetchSuccess,
    getZasilkovnaFetchFailure,
    getZasilkovnaFetchSuccess
} from './reducer';
import { ZasilkovnaCarriersResType, ZasilkovnaCarriersCarriersResType, ZasilkovnaResType } from 'src/types/zasilkovna';
import { formatPCKTData } from './functions';

const getZasilkovnaFetchRequest = async (carrierId?: number) => {
    const query = carrierId != null ? `?carrierId=${carrierId}` : '';
    const res = await api('get', `api/secure/shippers/zasilkovna/address${query}`);
    return res.data;
};

function* getZasilkovnaFetch(action: { type: string; payload?: number }) {
    try {
        const response: ZasilkovnaResType = yield call((): any => getZasilkovnaFetchRequest(action.payload));
        const formatedData = formatPCKTData(response.data);
        yield put(getZasilkovnaFetchSuccess(formatedData));
    } catch (error) {
        yield put(getZasilkovnaFetchFailure({ error }));
    }
}

export function* getZasilkovnaFetchWatch() {
    yield takeEvery('zasilkovna/getZasilkovnaFetch', getZasilkovnaFetch);
}

const getZasilkovnaCarriersListFetchRequest = async () => {
    const res = await api('get', `api/secure/shippers/zasilkovna/carries`);
    return res.data.data;
};

function* getZasilkovnaCarriersListFetch() {
    try {
        const response: ZasilkovnaCarriersCarriersResType[] = yield call((): any => getZasilkovnaCarriersListFetchRequest());
        yield put(getZasilkovnaCarriersFetchSuccess({ carriers: response, addresses: [] }));
    } catch (error) {
        yield put(getZasilkovnaCarriersFetchFailure({ error }));
    }
}

export function* getZasilkovnaCarriersListFetchWatch() {
    yield takeEvery('zasilkovna/getZasilkovnaCarriersListFetch', getZasilkovnaCarriersListFetch);
}

const getZasilkovnaCarriersFetchRequest = async (carrierId?: number) => {
    const query = carrierId != null ? `?carrierId=${carrierId}` : '';
    const resExternalAddresses = await api('get', `api/secure/shippers/zasilkovna/address-external${query}`);
    return { addresses: resExternalAddresses.data.carriers };
};

function* getZasilkovnaCarriersFetch(action: { type: string; payload?: number }) {
    try {
        const response: { addresses: any[] } = yield call((): any => getZasilkovnaCarriersFetchRequest(action.payload));
        yield put(getZasilkovnaCarriersFetchSuccess({ carriers: [], addresses: response.addresses }));
    } catch (error) {
        yield put(getZasilkovnaCarriersFetchFailure({ error }));
    }
}

export function* getZasilkovnaCarriersFetchWatch() {
    yield takeEvery('zasilkovna/getZasilkovnaCarriersFetch', getZasilkovnaCarriersFetch);
}
